module.exports = require('./chromecast.js')



/** WEBPACK FOOTER **
 ** ./src/plugins/chromecast/index.js
 **/